import React, {useEffect, useState} from 'react'
import {SpotifyApiContext} from 'react-spotify-api'
import Cookies from 'js-cookie';
import 'react-spotify-auth/dist/index.css'
import SpotifyLoggedInState from "./components/authed/SpotifyLoggedInState";
import SpotifyLoggedOutState from "./components/landing/SpotifyLoggedOutState";

function App() {
    const [spotifyAuthToken, setSpotifyAuthToken] = useState()

    useEffect(() => {
        setSpotifyAuthToken(Cookies.get('spotifyAuthToken'))
    }, [Cookies.get('spotifyAuthToken')])

    const token = Cookies.get('spotifyAuthToken')

    return (
        <div className='app'>
            {
                token ?
                    <SpotifyApiContext.Provider value={token}>
                        <SpotifyLoggedInState
                            token={token}
                        />
                    </SpotifyApiContext.Provider>
                    :
                    <SpotifyLoggedOutState/>
            }
            <h5>© Matthew Kempa 2020</h5>
        </div>
    )
}

export default App;
